import { WizardStepTreeSnapshot } from '../interfaces/wizard-step';

function getWizardCurrentStepGroupIndex(snapshot: WizardStepTreeSnapshot): number {
  return snapshot.children.findIndex(child => {
    return child.active;
  });
}

function getWizardCurrentStepGroup(snapshot?: WizardStepTreeSnapshot): {
  currentGroup: WizardStepTreeSnapshot | null;
  currentIndex: number;
} {
  const defaultReturnValue = {
    currentGroup: null,
    currentIndex: -1
  };

  if (!snapshot) {
    return defaultReturnValue;
  }

  const currentStepGroupIndex = getWizardCurrentStepGroupIndex(snapshot);

  if (currentStepGroupIndex < 0) {
    return {
      currentGroup: null,
      currentIndex: -1
    };
  }

  return {
    currentGroup: snapshot.children[currentStepGroupIndex],
    currentIndex: currentStepGroupIndex
  };
}

export function getCurrentWizardStepIndex(currentGroup: WizardStepTreeSnapshot | null): number {
  if (!currentGroup) {
    return -1;
  }

  return currentGroup.children.findIndex(child => {
    return child.active;
  });
}

export function getWizardCurrentStepInfo(snapshot?: WizardStepTreeSnapshot): {
  currentStepGroupIndex: number;
  currentStepGroup: WizardStepTreeSnapshot | null;
  currentStepIndex: number;
} {
  const { currentGroup, currentIndex } = getWizardCurrentStepGroup(snapshot);
  const stepIndex = getCurrentWizardStepIndex(currentGroup);

  return {
    currentStepGroup: currentGroup,
    currentStepGroupIndex: currentIndex,
    currentStepIndex: stepIndex
  };
}
